import { SocialName } from "@cede/types";
import { create } from "zustand";

export const STEPS = {
  ChooseCEX: "ChooseCEX",
  LinkAccount: "LinkAccount",
  ApiKeys: "ApiKeys",
  LinkSocials: "LinkSocials",
} as const;

export type StepType = (typeof STEPS)[keyof typeof STEPS];

export const FLOW_TYPES = {
  STANDALONE: "standalone",
  READY_TO_USE: "ready-to-use",
  RELINK: "relink",
  ONBOARDING: "onboarding",
} as const;

export type FlowType = (typeof FLOW_TYPES)[keyof typeof FLOW_TYPES];

interface ConnectState {
  openConnectModal: boolean;
  setOpenConnectModal: (value: boolean) => void;
  activeStep: StepType;
  setActiveStep: (value: StepType) => void;
  exchangeIds: string[];
  setExchangeIds: (value: string[]) => void;
  socialAccountsRequired: SocialName[];
  setSocialAccountsRequired: (value: SocialName[]) => void;
  /**
   * @remarks
   * The flow type is used to determine the flow of the connect modal
   * - "standalone": the modal can be used to connect all the exchanges
   * - "ready-to-use": the modal should be used to connect 1 exchange and then let the user use the hub
   * - "relink": the modal should be used to relink an exchange with wrong permissions
   * - "onboarding": the modal should be used to link an exchange for onboarding
   */
  flowType: FlowType;
  setFlowType: (value: FlowType) => void;
}

export const useConnectStore = create<ConnectState>()((set) => ({
  openConnectModal: false,
  setOpenConnectModal: (value) => set({ openConnectModal: value }),
  activeStep: STEPS.ChooseCEX,
  setActiveStep: (value) => set({ activeStep: value }),
  exchangeIds: [],
  setExchangeIds: (value) => set({ exchangeIds: value }),
  socialAccountsRequired: [],
  setSocialAccountsRequired: (value) => set({ socialAccountsRequired: value }),
  flowType: FLOW_TYPES.STANDALONE,
  setFlowType: (value) => set({ flowType: value }),
}));
